module.exports = __webpack_public_path__ + "static/media/fastify.43831f4a.svg";